import { render } from "./PostForm.vue?vue&type=template&id=38087d98"
import script from "./PostForm.vue?vue&type=script&lang=js"
export * from "./PostForm.vue?vue&type=script&lang=js"

import "./PostForm.vue?vue&type=style&index=0&id=38087d98&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__